// Client-safe shared helpers for the Expert Tips blog system.

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 90);
}

export function citySlug(name: string): string {
  return slugify(name);
}

export const EXPERT_TIPS_BASE = "/expert-tips";

export type AudienceType = "residential" | "commercial";

export function audienceLabel(a: string): string {
  return a === "commercial" ? "Commercial" : "Residential";
}
